export const factions = [
  {
    id: 1,
    type: "chapter",
    name: "Chapter",
    bannerFrontImageSrc: "images/factions/chapter/generic/banner_front.png",
    // bannerBackImageSrc: "images/factions/chapter/generic/banner_back.png",
    bannerAlternativeFront:
      "images/factions/chapter/generic/banner_alternative.png",

    shrine: "images/factions/chapter/generic/shrine.png",
    shrineAlternative: "images/factions/chapter/generic/shrine_alternative.png",
  },
  {
    id: 2,
    type: "demon",
    name: "Demon",
    bannerFrontImageSrc: "images/factions/demon/generic/banner_front.png",
    // bannerBackImageSrc: "images/factions/demon/generic/banner_back.png",
    bannerAlternativeFront:
      "images/factions/demon/generic/banner_alternative.png",
    shrine: "images/factions/demon/generic/shrine.png",
    shrineAlternative: "images/factions/demon/generic/shrine_alternative.png",
  },
  {
    id: 3,
    type: "faceless",
    name: "Faceless",
    bannerFrontImageSrc: "images/factions/faceless/generic/banner_front.png",
    // bannerBackImageSrc: "images/factions/faceless/generic/banner_back.png",
    bannerAlternativeFront:
      "images/factions/faceless/generic/banner_alternative.png",
    shrine: "images/factions/faceless/generic/shrine.png",
    shrineAlternative:
      "images/factions/faceless/generic/shrine_alternative.png",
  },
  {
    id: 4,
    type: "dvergar",
    name: "Dvergar",
    bannerFrontImageSrc: "images/factions/dvergar/generic/banner_front.png",
    // bannerBackImageSrc: "images/factions/dvergar/generic/banner_back.png",
    bannerAlternativeFront:
      "images/factions/dvergar/generic/banner_alternative.png",
    shrine: "images/factions/dvergar/generic/shrine.png",
    shrineAlternative: "images/factions/dvergar/generic/shrine_alternative.png",
  },
  {
    id: 5,
    type: "rhazack",
    name: "Rha-Zack",
    bannerFrontImageSrc: "images/factions/rhazack/generic/banner_front.png",
    // bannerBackImageSrc: "images/factions/rha-zack/generic/banner_back.png",
    bannerAlternativeFront:
      "images/factions/rhazack/generic/banner_alternative.png",
    shrine: "images/factions/rhazack/generic/shrine.png",
    shrineAlternative: "images/factions/rhazack/generic/shrine_alternative.png",
  },
  {
    id: 6,
    type: "reborn",
    name: "Reborn",
    bannerFrontImageSrc: "images/factions/reborn/generic/banner_front.png",
    // bannerBackImageSrc: "images/factions/reborn/generic/banner_back.png",
    bannerAlternativeFront:
      "images/factions/reborn/generic/banner_alternative.png",
    shrine: "images/factions/reborn/generic/shrine.png",
    shrineAlternative: "images/factions/reborn/generic/shrine_alternative.png",
  },
  {
    id: 7,
    type: "darkness",
    name: "Darkness",
    bannerFrontImageSrc: "images/factions/darkness/generic/banner_front.png",
    bannerBackImageSrc: "images/factions/darkness/generic/banner_back.png",
    bannerAlternativeFront:
      "images/factions/darkness/generic/banner_alternative.png",
    bannerAlternativeBack:
      "images/factions/darkness/generic/banner_alternative_back.png",
    shrine: "images/factions/darkness/generic/shrine.png",
    shrineAlternative:
      "images/factions/darkness/generic/shrine_alternative.png",
  },
];
